/* RESPONSIBLE TEAM: team-proactive-support */
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { computed } from '@ember/object';

export default class UserAgentDetector {
  private get userAgent(): string {
    return navigator.userAgent;
  }

  private get vendor(): string {
    return navigator.vendor;
  }

  @computed('userAgent')
  get isIE(): boolean {
    return /Trident\/./.test(this.userAgent);
  }

  @computed('userAgent')
  get isEdge(): boolean {
    return /Edge/.test(this.userAgent);
  }

  @computed('userAgent')
  get isFirefox(): boolean {
    return /Gecko\/\d+\sFirefox\/\d+/.test(this.userAgent);
  }

  @computed('userAgent', 'vendor')
  get isSafari(): boolean {
    return /Apple/i.test(this.vendor) && /Safari/i.test(this.userAgent);
  }

  @computed('userAgent')
  get isChrome(): boolean {
    return /Chrome/.test(this.userAgent) && !/Edge/i.test(this.userAgent);
  }
}
